import { action, observable, makeObservable } from 'mobx';

import { Constructor } from './types';

const Searchable = <T extends Constructor>(superclass: T) => {
  class SearchableClass extends superclass {
    constructor(...args: any[]) {
      super(...args);
      makeObservable(this);
    }

    @observable
    searchQuery: string | undefined = undefined;

    @action
    setSearch = (query: string | undefined) => {
      this.searchQuery = query || undefined;
    };
  }
  return SearchableClass;
};

export default Searchable;
